import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import ColorPickerGradient from 'vue2-color-picker-gradient'
import VueQRCodeComponent from 'vue-qrcode-component'

import router from './router'
import store from './store'
import App from './App.vue'

// Custom CSS
import './assets/css/styles.css'
import './assets/css/theme-setting.css'

// Global Components
import './global-components'

// 3rd party plugins
import '@axios'
import '@/libs/acl'
import '@/libs/clipboard'
import '@/libs/portal-vue'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'

import 'vue-select/dist/vue-select.css'

Vue.component('qr-code', VueQRCodeComponent)
// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.use(ColorPickerGradient)
// Composition API
Vue.use(VueCompositionAPI)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
